module.exports = __webpack_public_path__ + "img/custom.80aa6326.png";